import React, { useState, useMemo } from 'react';
import useFetchData from '../../hooks/useFetchData';
import Tile from '../../components/Tile/Tile';
import SEO from '../../components/SEO/SEO';
import { useLanguage } from '../../context/LanguageContext';
import { getSentimentPageStructuredData } from '../../utils/structuredData';
import './Sentiment.css';

const Sentiment = () => {
  const { lang, t } = useLanguage();

  // WICHTIG: Für API/Worker die Instrument-Namen mit "-" verwenden
  const INSTRUMENTS = useMemo(
    () => ["us30", "nasdaq", "spx500", "ger30", "gold", "eur-usd", "gbp-jpy", "gbp-usd"],
    []
  );

  // Optional: URL sauber normalisieren, falls in Env ein Slash am Ende ist
  const API_URL = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');

  const { data, loading, error } = useFetchData(INSTRUMENTS, API_URL);
  const [expandedTiles, setExpandedTiles] = useState({});

  const toggleTile = (instrumentName) => {
    setExpandedTiles(prevState => {
      if (prevState[instrumentName]) {
        return { [instrumentName]: false };
      }
      return { [instrumentName]: true };
    });
  };

  const baseUrl = 'https://sentmo.com';

  return (
    <>
      <SEO
        title={t.seo.sentiment.title}
        description={t.seo.sentiment.description}
        keywords="Daily Sentiment, Long Short Positionen, US30 Sentiment, NASDAQ Sentiment, DAX Sentiment, Gold Sentiment, EURUSD Sentiment, GBPJPY Sentiment, GBPUSD Sentiment, Trading Analyse"
        canonicalUrl={`${baseUrl}/${lang}/sentiment`}
        lang={lang}
        alternateUrls={[
          { lang: 'de', url: `${baseUrl}/de/sentiment` },
          { lang: 'en', url: `${baseUrl}/en/sentiment` },
          { lang: 'x-default', url: `${baseUrl}/de/sentiment` }
        ]}
        structuredData={getSentimentPageStructuredData({
          lang,
          title: t.seo.sentiment.title,
          description: t.seo.sentiment.description
        })}
      />

      <div className="page sentiment-page">
        <h1>{t.sentiment.title}</h1>

        {loading && <div className="status">{t.sentiment.loading}</div>}
        {error && <div className="error">{t.sentiment.error}: {error}</div>}

        {!loading && !error && (
          <div className="tiles-container">
            {INSTRUMENTS.map(inst => (
              <Tile
                key={inst}
                instrumentName={inst}
                instrumentData={data[inst]}
                isExpanded={!!expandedTiles[inst]}
                toggleTile={toggleTile}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Sentiment;
